module.exports = {
	"pagination": {
		"ListDomains": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"output_token": "NextPageMarker",
			"result_key": "Domains"
		},
		"ListOperations": {
			"input_token": "Marker",
			"limit_key": "MaxItems",
			"output_token": "NextPageMarker",
			"result_key": "Operations"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/route53domains-2014-05-15.paginators.json
// module id = 711
// module chunks = 0